import AttendanceTeacherList from '@/controllers/attendance_teacher/attendance-teacher-list.js';
import CONFIG from "@/assets/js/config.js";

export default {
  extends : AttendanceTeacherList,
  data() {
    return {
      CONFIG,
      searchData: {
        employeeable_type: null,
        page: 1
      },
    }
  },

  methods: {
    selectToggle(id, index) {
      const itemCountOnPage = this.attendanceList.length; 
      this.selectToggleWithCount(id, index, itemCountOnPage);
    },
    reset() {
      this.searchData = { employeeable_type: this.getDefaultEmployeeableType()}
      this.search_status = false;
      this.setInitialDateRange();
      this.resetSelectedAll();
      this.getAttendanceList();
    },

    getDefaultEmployeeableType() {
      if (this.isHrOperator) {
        return null;
      }

      if (this.auth('admin').check()) {
        return CONFIG.EMPLOYEE_FLAG.STAFF;
      }

      if (this.auth('teacher').check()) {
        return CONFIG.EMPLOYEE_FLAG.TEACHER;
      }

      return null;
    },
  },

  mounted() {
    this.searchData.employeeable_type = this.getDefaultEmployeeableType();
  }
}
